<template>
  <div class="box_M">
    <div class="info_box_m recruit_detail_m">
      <div class="title">{{ content.enterpriseName }}-{{ content.jobVacancy }}</div>
      <div class="line"><h2>单位性质</h2><span>{{ content.jobVacancy }}</span></div>
      <div class="line"><h2>招聘职位</h2><span>{{ content.jobVacancy }}</span></div>
      <div class="line"><h2>学历</h2><span>{{ content.jobVacancy }}</span></div>
      <div class="line"><h2>招聘类型</h2><span>{{ content.jobVacancy }}</span></div>
      <div class="line"><h2>招聘职位</h2><span>{{ content.jobVacancy }}</span></div>
      <div class="line"><h2>工作经验</h2><span>{{ content.workYears }}</span></div>
      <div class="line"><h2>招聘人数</h2><span>{{ content.jobNum }}人</span></div>
      <div class="line"><h2>招聘类型</h2><span>{{ content.jobType }}</span></div>
      <div class="line"><h2>工作地址</h2><span>{{ content.workAddress }}</span></div>
      <div class="line"><h2>薪资范围</h2><span>{{ content.salaryRange }}</span></div>
      <div class="line">
        <h2>岗位职责</h2>
        <p>{{ content.responsibility }}</p>
      </div>
      <div class="line">
        <h2>任职要求</h2>
        <p>{{ content.jobSpecification }}</p>
      </div>
      <div class="line">
        <h2>福利待遇</h2>
        <p>{{ content.welfareTreatment }}</p>
      </div>
      <div class="line">
        <h2>公司简介</h2>
        <p>{{ content.companyIntroduction }}</p>
      </div>
      <div class="line"><h2>联系人</h2><span>{{ content.contactName }}</span></div>
      <div class="line"><h2>联系方式</h2><span>{{ content.mobile }}</span></div>
      <div class="line"><h2>联系邮箱</h2><span>{{ content.contactMail }}</span></div>
      <div class="btn_delivery" @click="showDialog=true">投递简历</div>
      <!-- 登录的dialog -->
      <van-dialog v-model="showDialog" :showConfirmButton="false" :closeOnClickOverlay="true">
        <van-form ref="form">
          <van-field
              required
              clearable
              v-model="form.mobile"
              label="手机号:"
              name="mobile"
              maxlength="11"
              autocomplete="off"
              :rules="rules.mobile"/>
          <van-cell class="code_box">
            <van-field
                required
                v-model="form.code"
                label="验证码:"
                name="code"
                autocomplete="off"
                :rules="rules.code"/>
            <div class="getCode" v-show="!showVerCoding" @click="getCode">获取验证码</div>
            <van-count-down v-show="showVerCoding" :time="60000" :auto-start="false" format="ss秒后重新获取" ref="countdown"
                            @finish="finish"/>
          </van-cell>

          <van-button round block type="info" @click="onSubmit('form')">提交</van-button>
        </van-form>
      </van-dialog>
    </div>
    <bottom-menu></bottom-menu>
  </div>
</template>

<script>
import {getRecruitmentDetail, getSmsCode, createDelivery, getUserInfo, smsLogin} from '@/service/api.js'
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import {encrypt} from "../../../utils/jsencrypt";

export default {
  components: {BottomMenu},
  data() {
    return {
      showDialog: false,
      showVerCoding: false,
      form: {
        mobile: '',
        code: '',
        recruitmentInfoId: '',
      },
      rules: {
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'onBlur'},
          {
            validator: value => {
              return /^1\d{10}$/.test(value)
            },
            message: '请输入正确的手机号',
            trigger: 'onBlur'
          }
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'onBlur'}
        ],
      },
      content: {
        enterpriseName: '',
        jobVacancy: '',
        jobNum: '',
        jobType: '',
        workAddress: '',
        salaryRange: '',
        responsibility: '',
        jobSpecification: '',
        welfareTreatment: '',
        companyIntroduction: '',
        contactName: '',
        mobile: '',
        contactMail: '',
        workYears: ''
      },
      salaryRangeOptions: {
        0: "面议",
        1: "3000以下",
        2: "3000-5000",
        3: "5000-9000",
        4: "9000以上",
      },
      workYearsOptions: {
        0: "不限",
        1: "1-3年",
        2: "3-5年",
        3: "5-10年",
        4: "10年以上",
      },
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate().then(() => {
        smsLogin(this.form).then(data => {
          if (data.code !== 0) {
            this.$toast(data.msg)
          } else {
            if (data.token) {
              localStorage.setItem('token', data.token)
              getUserInfo().then(data => {
                console.log(data);
                if (data.code !== 0) {
                  this.$toast(data.msg)
                } else {
                  this.$store.commit('setUserInfo', data.data)

                  // 区分企业用户和个人用户
                  if (data.data.certification) {
                    this.showDialog = false
                    this.$toast('企业用户不能投递简历')
                  } else {
                    this.form.recruitmentInfoId = this.$route.params.id
                    createDelivery(this.form).then(data => {
                      console.log(data);
                      if (data.code === 1114) {
                        localStorage.setItem('token', data.token)
                        this.$router.push({name: 'M_PersonalResume'})
                        this.$toast(data.msg)
                        return
                      }
                      if (data.code !== 0) {
                        this.$toast(data.msg)
                      } else {
                        if (data.token) {
                          this.$toast('投递成功')
                          localStorage.setItem('token', data.token)
                        }
                      }

                    })

                    this.showDialog = false
                  }
                }

              })
            }
            console.log(this.$store.state.userInfo);
          }
        })
      }).catch(e => {
        console.log(e);
      });
    },
    // 获取验证码倒计时结束
    finish() {
      this.showVerCoding = false
      this.$refs.countdown.reset()
    },
    // 获取验证码
    getCode() {
      this.$refs.form.validate('phone').then(() => {
        this.showVerCoding = true
        this.$refs.countdown.start()
        getSmsCode({mobile: encrypt(''+this.form.phone)}).then(data => {
          if (data.code !== 0) {
            this.$toast(data.msg)
          } else {
            console.log(data);
          }
        })
      }).catch(() => {
        this.$toast('请填写正确的手机号')
      })
    },
  },
  mounted() {
    getRecruitmentDetail(this.$route.params.id).then(data => {
      console.log(data);
      if (data.code !== 0) {
        this.$toast(data.msg)
      } else {
        this.content = Object.assign(this.content, data.data)
        this.content.salaryRange = this.salaryRangeOptions[this.content.salaryRange]
        this.content.workYears = this.workYearsOptions[this.content.workYears]
        this.content.jobType = JSON.parse(this.content.jobType).join(',')
      }
    });
  },
}
</script>

<style>

</style>
